/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
==========================================================================================*/

import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';

Vue.use(Vuex);

// Plugin Vuex Persistance
import { createVuexPersistance } from './vuex-persistance-plugin';

// Global
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Module
import context from './context/moduleContext';
import employee from './moduleEmployee';
import layout from './moduleLayout';
import organization_unit from './moduleOrganizationUnit';
import deviceWideProfile from './moduleDeviceWideProfile';
import deviceDeepProfile from './moduleDeviceDeepProfile';
import websiteDeepProfile from './moduleWebsiteDeepProfile';
import websiteDeepTaskResult from './moduleWebsiteDeepTaskResult';
import websiteWideProfile from './moduleWebsiteWideProfile';
import websiteWideTaskResult from './moduleWebsiteWideTaskResult';
import deviceWideTaskResult from './moduleDeviceWideTaskResult';
import deviceDeepTaskResult from './moduleDeviceDeepTaskResult';
import device from './moduleDevice';
import devicesIssues from './moduleDevicesIssues';
import scanEngine from './moduleScanEngine';
import websiteIssues from './moduleWebsiteIssues';
import website from './moduleWebsite';
import users from './moduleUsers';
import roles from './moduleRoles';
import proxy from './moduleProxy';
import metasploit from './moduleMetasploit';
import userLog from './moduleUserLog';
import dataLake from './moduleDataLake';
import devicePort from './moduleDevicePort';
import deviceWideTaskResultDevice from './moduleDeviceWideTaskResultDevice';
import deviceWideTaskResultIssues from './moduleDeviceWideTaskResultIssues';
import websiteWideTaskResultDevice from './moduleWebsiteWideTaskResultDevice';
import websiteWideTaskResultIssues from './moduleWebsiteWideTaskResultIssues';
import networkLocation from './moduleNetworkLocation';
import exploit from './moduleExploit';
import attackProfile from './moduleAttackProfile';
import poc from './modulePoc';
import leakAccount from './moduleLeakAccount';
import leakSource from './moduleLeakSource';
import proxyLog from './moduleProxyLog';
import proxyHistory from './moduleProxyHistory';
import nzTemplate from './moduleNzTemplate';
import cvePoc from './moduleCvePoc';
import cvePocTask from './moduleCvePocTask';
import exploitdbPoc from './moduleExploitdbPoc';
import websiteIp from './moduleWebsiteIp';
import scheduleJob from './moduleScheduleJob';
import scheduleLog from './moduleScheduleLog';
import cveDetect from './moduleCveDetect';
import watchlist from './moduleWatchlist';
import moduleSetting from './moduleSetting';
import exploitDB from './moduleExploitDB';
import misp from './moduleMISP';
import reddit from './moduleReddit';
import monitor from './moduleMonitor';
import rss from './moduleRss';
import channel from './moduleChannel';
import evidences from './moduleEvidences';

// Init instance of store
const store = new Vuex.Store({
	// plugins:
	// 	process.env.NODE_ENV !== 'production'
	// 		? [createLogger(), createVuexPersistance()]
	// 		: [createVuexPersistance()],
	getters,
	mutations,
	state,
	actions,
	modules: {
		context,
		employee,
		layout,
		organization_unit,
		deviceWideProfile,
		deviceDeepProfile,
		device,
		devicesIssues,
		scanEngine,
		websiteDeepProfile,
		websiteDeepTaskResult,
		websiteIssues,
		website,
		users,
		roles,
		websiteWideProfile,
		websiteWideTaskResult,
		deviceWideTaskResult,
		deviceDeepTaskResult,
		proxy,
		metasploit,
		userLog,
		dataLake,
		devicePort,
		deviceWideTaskResultDevice,
		deviceWideTaskResultIssues,
		websiteWideTaskResultDevice,
		websiteWideTaskResultIssues,
		networkLocation,
		exploit,
		attackProfile,
		poc,
		leakAccount,
		leakSource,
		proxyLog,
		proxyHistory,
		nzTemplate,
		cvePoc,
		cvePocTask,
		exploitdbPoc,
		websiteIp,
		scheduleJob,
		scheduleLog,
		cveDetect,
		watchlist,
		moduleSetting,
		exploitDB,
		misp,
		reddit,
		monitor,
		rss,
		channel,
		evidences
	},
	strict: false
});

export default store;
